[
  {
    "id": "TB-M6P-001",
    "module": "Taalbegrip",
    "difficulty": 104,
    "question": "Lees de tekst:\n\n\"De reuzenpanda eet bijna alleen bamboe. Hij besteedt 12 uur per dag aan eten. Toch krijgt hij er weinig energie uit. Daarom beweegt de panda zo min mogelijk.\"\n\nWaarom beweegt de panda zo weinig?",
    "options": [
      "Omdat bamboe weinig energie geeft",
      "Omdat hij lui is",
      "Omdat hij te dik is",
      "Omdat hij ziek is"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verbanden",
    "subSkill": "oorzaak_gevolg",
    "familyId": "TB-PANDA-ENERGIE",
    "explanation": "De tekst legt een oorzaak-gevolg uit: bamboe geeft weinig energie (oorzaak), daarom beweegt hij weinig (gevolg). Het signaalwoord 'daarom' maakt dit duidelijk.",
    "distractorExplanations": {
      "1": "De tekst zegt niet dat hij lui is, maar dat hij energie spaart.",
      "2": "Gewicht wordt niet als reden genoemd.",
      "3": "Ziekte wordt niet genoemd."
    }
  },
  {
    "id": "TB-M6P-002",
    "module": "Taalbegrip",
    "difficulty": 104,
    "question": "Lees de tekst:\n\n\"Vroeger werden brieven bezorgd door postduiven. De duif vloog met een briefje aan zijn poot naar huis. Dit was de snelste manier om berichten te versturen. Tegenwoordig gebruiken we e-mail en WhatsApp.\"\n\nWat is het verschil tussen vroeger en nu?",
    "options": [
      "Vroeger gebruikten mensen postduiven, nu gebruiken we digitale berichten",
      "Vroeger was er geen post",
      "Nu gebruiken we ook postduiven",
      "Er is geen verschil"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "vergelijken",
    "familyId": "TB-POSTDUIF",
    "explanation": "De tekst vergelijkt vroeger (postduiven) met nu (e-mail, WhatsApp). Het signaalwoord 'tegenwoordig' markeert het verschil.",
    "distractorExplanations": {
      "1": "Er was wel post, via postduiven.",
      "2": "De tekst zegt dat postduiven van vroeger zijn.",
      "3": "Er is wel een verschil: de manier van communiceren."
    }
  },
  {
    "id": "TB-M6P-003",
    "module": "Taalbegrip",
    "difficulty": 104,
    "question": "Lees het krantenartikel:\n\n\"STORM VERWACHT IN NEDERLAND\nVanaf morgenavond wordt windkracht 9 verwacht. Het KNMI waarschuwt voor omvallende bomen en loswaaiende dakpannen. Blijf zoveel mogelijk binnen.\"\n\nWat is het doel van dit artikel?",
    "options": [
      "Mensen waarschuwen voor gevaarlijk weer",
      "Mensen informeren over het KNMI",
      "Mensen vertellen dat bomen kunnen omvallen",
      "Mensen uitnodigen om naar buiten te gaan"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "doel_schrijver",
    "familyId": "TB-STORM-DOEL",
    "explanation": "Het artikel waarschuwt ('waarschuwt', 'blijf binnen') voor gevaarlijk weer. Het doel is mensen beschermen.",
    "distractorExplanations": {
      "1": "Het KNMI wordt genoemd, maar het doel is waarschuwen.",
      "2": "Omvallende bomen is een detail, niet het hoofddoel.",
      "3": "Het artikel zegt juist: 'Blijf zoveel mogelijk binnen.'"
    }
  },
  {
    "id": "TB-M6P-004",
    "module": "Taalbegrip",
    "difficulty": 104,
    "question": "Wat betekent het woord 'besteedt' in de zin: 'Hij besteedt 12 uur per dag aan eten.'",
    "options": [
      "Gebruikt (tijd) voor iets",
      "Betaalt voor iets",
      "Vindt iets leuk",
      "Vergeet iets"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-BESTEEDT",
    "explanation": "'Besteden' kan gaan over geld OF tijd. Hier gaat het over tijd: hij gebruikt 12 uur voor eten.",
    "distractorExplanations": {
      "1": "Besteden kan ook 'betalen' betekenen, maar hier gaat het over tijd.",
      "2": "Leuk vinden is iets anders.",
      "3": "Vergeten is iets anders."
    }
  },
  {
    "id": "TB-M6P-005",
    "module": "Taalbegrip",
    "difficulty": 104,
    "question": "Lees de tekst:\n\n\"De schooltuin is een groot succes. Leerlingen leren er groenten kweken. Ze planten wortels, tomaten en sla. Bovendien leren ze hoe belangrijk gezond eten is.\"\n\nWat leren de leerlingen in de schooltuin? (Twee dingen)",
    "options": [
      "Groenten kweken en het belang van gezond eten",
      "Alleen groenten kweken",
      "Alleen gezond eten",
      "Koken en bakken"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-SCHOOLTUIN",
    "explanation": "De tekst noemt twee dingen: groenten kweken (zin 2-3) en het belang van gezond eten (zin 4, na 'bovendien').",
    "distractorExplanations": {
      "1": "Er worden twee dingen genoemd, niet één.",
      "2": "Er worden twee dingen genoemd, niet één.",
      "3": "Koken en bakken worden niet genoemd."
    }
  },
  {
    "id": "TB-M6P-006",
    "module": "Taalbegrip",
    "difficulty": 104,
    "question": "Lees de tekst:\n\n\"Sommige vogels vliegen duizenden kilometers om te overwinteren in warme landen. De boerenzwaluw vliegt bijvoorbeeld van Nederland naar Zuid-Afrika. In het voorjaar komt hij weer terug.\"\n\nWaarom vliegen sommige vogels naar warme landen?",
    "options": [
      "Om te overwinteren (de winter door te brengen)",
      "Omdat ze verdwaald zijn",
      "Om op vakantie te gaan",
      "Omdat ze niet van Nederland houden"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-TREKVOGELS",
    "explanation": "De tekst zegt: 'om te overwinteren in warme landen'. Ze brengen de winter door op een warmere plek.",
    "distractorExplanations": {
      "1": "Ze zijn niet verdwaald, ze doen het elk jaar.",
      "2": "Het is geen vakantie, het is overleving.",
      "3": "Ze komen juist terug naar Nederland in het voorjaar."
    }
  },
  {
    "id": "TB-M6P-007",
    "module": "Taalbegrip",
    "difficulty": 104,
    "question": "Lees de tekst:\n\n\"Water kan drie vormen aannemen. Als het koud genoeg is, wordt water ijs. Als je water verhit, wordt het stoom. Bij kamertemperatuur is het gewoon vloeibaar.\"\n\nWat zijn de drie vormen van water?",
    "options": [
      "Ijs, vloeibaar water en stoom",
      "Koud, warm en heet",
      "Regen, sneeuw en hagel",
      "Zee, rivier en meer"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "letterlijk_begrip",
    "familyId": "TB-WATER-VORMEN",
    "explanation": "De tekst noemt drie vormen: ijs (vast), vloeibaar water, en stoom (gas).",
    "distractorExplanations": {
      "1": "Dat zijn temperaturen, geen vormen.",
      "2": "Dat zijn soorten neerslag.",
      "3": "Dat zijn waterlichamen, geen vormen van water."
    }
  },
  {
    "id": "TB-M6P-008",
    "module": "Taalbegrip",
    "difficulty": 104,
    "question": "Wat betekent het woord 'overwinteren' in de tekst over trekvogels?",
    "options": [
      "De winter doorbrengen op een andere plek",
      "De winter overleven zonder eten",
      "De hele winter slapen",
      "De winter vieren"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-OVERWINTEREN",
    "explanation": "'Overwinteren' betekent de winter doorbrengen, vaak op een warmere plek.",
    "distractorExplanations": {
      "1": "Dat zou 'vasten' of 'honger lijden' zijn.",
      "2": "Dat is een winterslaap (bij beren bijvoorbeeld).",
      "3": "Overwinteren is geen feest."
    }
  },
  {
    "id": "TB-M6P-009",
    "module": "Taalbegrip",
    "difficulty": 104,
    "question": "Lees de tekst:\n\n\"De Eiffeltoren in Parijs is 330 meter hoog. Hij werd gebouwd in 1889 voor de Wereldtentoonstelling. Eerst vonden veel Parijzenaars hem lelijk. Nu is het het beroemdste gebouw van Frankrijk.\"\n\nWat veranderde er in de mening over de Eiffeltoren?",
    "options": [
      "Eerst vonden mensen hem lelijk, nu is hij beroemd",
      "Hij werd steeds hoger",
      "Hij werd verplaatst naar een andere stad",
      "Er veranderde niets"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "conclusie_trekken",
    "familyId": "TB-EIFFELTOREN",
    "explanation": "De tekst beschrijft een verandering: 'Eerst... lelijk' → 'Nu... beroemdste gebouw'. De mening veranderde van negatief naar positief.",
    "distractorExplanations": {
      "1": "De hoogte veranderde niet.",
      "2": "De toren staat nog steeds in Parijs.",
      "3": "Er veranderde wel iets: de mening."
    }
  },
  {
    "id": "TB-M6P-010",
    "module": "Taalbegrip",
    "difficulty": 104,
    "question": "Lees de tekst:\n\n\"Kameleons kunnen van kleur veranderen. Veel mensen denken dat ze dit doen om zich te verstoppen. Maar eigenlijk veranderen ze van kleur om te communiceren met andere kameleons en om hun temperatuur te regelen.\"\n\nWaarom veranderen kameleons echt van kleur?",
    "options": [
      "Om te communiceren en hun temperatuur te regelen",
      "Om zich te verstoppen",
      "Omdat ze bang zijn",
      "Omdat ze honger hebben"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "conclusie_trekken",
    "familyId": "TB-KAMELEON",
    "explanation": "De tekst zegt: 'Maar eigenlijk...' — het woord 'eigenlijk' geeft de echte reden aan: communicatie en temperatuurregeling.",
    "distractorExplanations": {
      "1": "De tekst zegt dat dit een misverstand is ('veel mensen denken').",
      "2": "Angst wordt niet als reden genoemd.",
      "3": "Honger wordt niet als reden genoemd."
    }
  }
]